import action from "../action";
export const SET_ROOM = "SET_ROOM";
export const SET_MAILCHIMP_ID = "SET_MAILCHIMP_ID";
export const END_GAME = "END_GAME";
export const SET_GAME_NAME = "SET_GAME_NAME";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_MOBILE_APP = "SET_MOBILE_APP";
export const HOW_TO_PLAY = "HOW_TO_PLAY";
export const SHOW_LEAVE_GAME = "SHOW_LEAVE_GAME";
export const SET_SESSION = "SET_SESSION";
export const SET_BRANCH_JOIN_CODE = "SET_BRANCH_JOIN_CODE";
export const SET_BINGO_BOARD = "SET_BINGO_BOARD";
export const SET_SLICE_GAME_CODE = "SET_SLICE_GAME_CODE";
export const SET_GAH_NEW_CARD = "SET_GAH_NEW_CARD";
export const SET_HEADER_DROP_DOWN = "SET_HEADER_DROP_DOWN";
export const SET_DROP_DOWN_HELP = "SET_DROP_DOWN_HELP";
export const SET_READY_TO_VOTE = "SET_READY_TO_VOTE";
export const SET_DW20_NEW_CARD = "SET_DW20_NEW_CARD";
export const SET_CT_SELECTED_PLAYER = "SET_CT_SELECTED_PLAYER";
export const SET_CT_SELECTED_CARD = "SET_CT_SELECTED_CARD";
export const SET_CT_STEAL_BUTTON = "SET_CT_STEAL_BUTTON";
export const SET_CT_DICE_SPECIAL6 = "SET_CT_DICE_SPECIAL6";
export const SET_CHPT_NEW_CARD = "SET_CHPT_NEW_CARD";
export const SET_CHPT_RESULT_MODAL = "SET_CHPT_RESULT_MODAL";
export const SET_OCH_NEW_CARD = "SET_OCH_NEW_CARD";



export const setRoom = (data) =>
  action({
    type: SET_ROOM,
    data
  });

export const setSession = (data) =>
  action({
    type: SET_SESSION,
    data
  });
export const setBranchJoincode = (data) =>
  action({
    type: SET_BRANCH_JOIN_CODE,
    data
  });

export const setSliceGameCode = (data) =>
  action({
    type: SET_SLICE_GAME_CODE,
    data
  });

export const setGameName = (data) =>
  action({
    type: SET_GAME_NAME,
    data
  });

export const endGame = (data) =>
  action({
    type: END_GAME,
    data
  });

export const setCurrentUser = (data) =>
  action({
    type: SET_CURRENT_USER,
    data
  });
// true if the app is opened in mobile-app using iframe, false if the app is opened in the browser of mobile
export const set_mobile_app = (data) =>
  action({
    type: SET_MOBILE_APP,
    data
  });

export const how_to_play = (data) =>
  action({
    type: HOW_TO_PLAY,
    data
  });
export const show_leave_game = (data) =>
  action({
    type: SHOW_LEAVE_GAME,
    data
  });
export const set_bingo_board = (data) =>
  action({
    type: SET_BINGO_BOARD,
    data
  });

export const set_gah_new_card = (data) =>
  action({
    type: SET_GAH_NEW_CARD,
    data
  });
export const set_header_drop_down = (data) =>
  action({
    type: SET_HEADER_DROP_DOWN,
    data
  });
export const set_drop_down_help = (data) =>
  action({
    type: SET_DROP_DOWN_HELP,
    data
  });
export const set_ready_to_vote = (data) =>
  action({
    type: SET_READY_TO_VOTE,
    data
  });
export const set_dw20_new_card = (data) =>
  action({
    type: SET_DW20_NEW_CARD,
    data
  });
export const set_chpt_new_card = (data) =>
  action({
    type: SET_CHPT_NEW_CARD,
    data
  });
export const set_ct_selected_player = (data) =>
  action({
    type: SET_CT_SELECTED_PLAYER,
    data
  });
export const set_ct_selected_card = (data) =>
  action({
    type: SET_CT_SELECTED_CARD,
    data
  });
export const set_ct_steal_button = (data) =>
  action({
    type: SET_CT_STEAL_BUTTON,
    data
  });
export const set_ct_dice_special6 = (data) =>
  action({
    type: SET_CT_DICE_SPECIAL6,
    data
  });
  export const set_chpt_result_modal = (data) =>
  action({
    type: SET_CHPT_RESULT_MODAL,
    data
  });
  export const set_och_new_card = (data) =>
  action({
    type: SET_OCH_NEW_CARD,
    data
  });
